export default "__VITE_ASSET__C_Wl_N$P__"